import React from "react";

const ContactInfo = () => {
  return (
    <section className="contact-details-area ptb-100">
      <div className="container">
        <div className="section-title contact-details-title">
          <span className="sub-title">
            What Happens Next
          </span>

          <h2>
            A Simple Path From Enquiry to Clear Next Steps
          </h2>

          <p>
            You do not need to know the exact technical answer before getting
            in touch. Share what you want to implement, improve, automate,
            secure, or govern and CloudLogic will help identify the right first
            step for Microsoft 365, Azure, SharePoint, Teams, security,
            compliance, or managed IT support.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6">
            <div className="contact-details-card">
              <div className="contact-details-icon">
                <i className="bx bx-map"></i>
              </div>

              <h3>1. Send Your Concern</h3>

              <p>Tell us what is happening or what you want reviewed.</p>

              <span className="contact-details-note">
                Examples: Microsoft 365, SharePoint, Teams, automation, security
              </span>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="contact-details-card contact-details-card-featured">
              <div className="contact-details-icon">
                <i className="bx bx-phone-call"></i>
              </div>

              <h3>2. CloudLogic Reviews It</h3>

              <p>We assess whether you need a health check, consultation, project scope, or support response.</p>

              <span className="contact-details-note">
                You receive a practical recommendation, not a generic sales reply
              </span>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="contact-details-card">
              <div className="contact-details-icon">
                <i className="bx bx-time-five"></i>
              </div>

              <h3>3. Get the Right Next Step</h3>

              <p>Book a Microsoft 365 Health Check or discuss a scoped service.</p>

              <span className="contact-details-note">
                Melbourne-based support with remote delivery available
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
